/**
 * AboutTeam.tsx — Gold Garage Door / About Us · Section 4/10
 * Cream · 3 real action photos editorial collage. MOBILE: real <style> media queries.
 * IMAGES: 98e6b5da->about-team-spring-repair.webp · IMG_6361->about-team-cable-install.webp
 *         PHOTO-2026->about-team-commercial-door.webp
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — keep.
 */

const IMG_TALL = "/wp-content/uploads/2026/06/about-team-spring-repair.webp";
const IMG_WIDE = "/wp-content/uploads/2026/06/about-team-cable-install.webp";
const IMG_SQUARE = "/wp-content/uploads/2026/06/about-team-commercial-door.webp";
const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
export default function AboutTeam() {
  return <section id="about-team" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .at-collage { display: grid; grid-template-columns: 1.05fr 1.35fr; grid-template-rows: auto auto; gap: 1.25rem; }
        .at-tall { grid-row: 1 / 3; }
        @media (max-width: 760px) {
          .at-collage { grid-template-columns: 1fr; grid-template-rows: none; }
          .at-tall { grid-row: auto; }
          .at-collage figure img { min-height: 220px !important; height: 240px !important; }
          #about-team { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-at"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-at)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "5rem",
      right: "2rem",
      width: "60px",
      height: "60px",
      borderTop: `2px solid ${GOLD}55`,
      borderRight: `2px solid ${GOLD}55`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        maxWidth: "640px",
        marginBottom: "3rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>The Crew</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.75rem 0 0.75rem"
        }}>The same hands, on every driveway</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: INK,
          lineHeight: 1.7
        }}>These aren't stock photos. Every shot below is a real Gold Garage Door job across Sydney — springs, cables, roller and commercial doors, done by the family that owns the business.</p>
        </div>

        <div className="at-collage">
          <figure className="at-tall" style={{
          margin: 0,
          position: "relative",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 14px 44px rgba(8,20,56,0.16)"
        }}>
            <img src={IMG_TALL} alt="Gold Garage Door technician servicing an overhead garage door spring and cable in Sydney" width={520} height={680} loading="lazy" decoding="async" style={{
            width: "100%",
            height: "100%",
            minHeight: "420px",
            objectFit: "cover",
            display: "block"
          }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/98e6b5da-5f28-4e7a-9644-2bf8351ab70d.webp" />
            <figcaption style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "1.25rem",
            background: "linear-gradient(transparent, rgba(8,20,56,0.85))",
            color: "#fff"
          }}>
              <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: GOLD,
              textTransform: "uppercase"
            }}>Spring & cable service</div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "1.05rem",
              marginTop: "0.2rem"
            }}>Overhead torsion work, done safe</div>
            </figcaption>
          </figure>

          <figure style={{
          margin: 0,
          position: "relative",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 14px 44px rgba(8,20,56,0.16)"
        }}>
            <img src={IMG_WIDE} alt="Two Gold Garage Door technicians installing a garage door on ladders at a Sydney home" width={640} height={420} loading="lazy" decoding="async" style={{
            width: "100%",
            height: "100%",
            minHeight: "240px",
            objectFit: "cover",
            display: "block"
          }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/repair-hero-desktop.png" src="https://goldgaragedoor.com.au/wp-content/uploads/2026/06/repair-hero-desktop.webp" />
            <figcaption style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "1.1rem",
            background: "linear-gradient(transparent, rgba(8,20,56,0.85))",
            color: "#fff"
          }}>
              <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: GOLD,
              textTransform: "uppercase"
            }}>Two-tech installs</div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "1.02rem",
              marginTop: "0.2rem"
            }}>Bigger jobs, faster turnaround</div>
            </figcaption>
          </figure>

          <figure style={{
          margin: 0,
          position: "relative",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 14px 44px rgba(8,20,56,0.16)"
        }}>
            <img src={IMG_SQUARE} alt="Gold Garage Door technician at a commercial roller door installation in Sydney" width={640} height={420} loading="lazy" decoding="async" style={{
            width: "100%",
            height: "100%",
            minHeight: "240px",
            objectFit: "cover",
            display: "block"
          }} src="https://goldgaragedoor.com.au/wp-content/uploads/2026/06/PHOTO-2026-06-23-10-44-32.webp" />
            <figcaption style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "1.1rem",
            background: "linear-gradient(transparent, rgba(8,20,56,0.85))",
            color: "#fff"
          }}>
              <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: GOLD,
              textTransform: "uppercase"
            }}>Commercial & roller</div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "1.02rem",
              marginTop: "0.2rem"
            }}>Industrial-grade, residential care</div>
            </figcaption>
          </figure>
        </div>

        <div style={{
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        flexWrap: "wrap",
        background: "#fff",
        border: `1px solid ${GOLD}30`,
        borderRadius: "12px",
        padding: "1.1rem 1.5rem",
        boxShadow: "0 6px 24px rgba(8,20,56,0.06)"
      }}>
          <span style={{
          fontSize: "1.4rem"
        }}></span>
          <p style={{
          margin: 0,
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.95rem",
          color: INK,
          lineHeight: 1.5
        }}><strong style={{
            color: NAVY
          }}>Spot the shirt.</strong> If it doesn't say Gold Garage Door — it isn't us. Every tech turns up uniformed, ID-ready and in a sign-written van.</p>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}